export default __webpack_public_path__ + "static/GameController-55e5c84d42a4b1a2419f2d11d33eb59b.png";